<template>
  <div id="root-app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#root-app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue